import { render, staticRenderFns } from "./CostCenterAllocationEditor.vue?vue&type=template&id=03dbeab4&scoped=true"
import script from "./CostCenterAllocationEditor.vue?vue&type=script&lang=js"
export * from "./CostCenterAllocationEditor.vue?vue&type=script&lang=js"
import style0 from "./CostCenterAllocationEditor.vue?vue&type=style&index=0&id=03dbeab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dbeab4",
  null
  
)

export default component.exports